import { reduce } from "et3-type-guards";

import i18n, { Ti18nKeys } from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import { isBlankValue } from "../../../../../core/et3-field-grid";
import Et3Text from "../../../../../core/et3-text";
import { SURFACE_BORDER } from "../../../../../core/et3-theme/surface-constants";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import {
  FEATURE_ROW_GAP,
  FEATURE_ROW_HEIGHT,
  FEATURE_ROW_LABEL_FONT_SIZE,
  FEATURE_ROW_LABEL_WIDTH
} from "../feature-badge-row/feature-badge-row-constants";
import {
  EXPIRY_DATE_FONT_SIZE,
  EXPIRY_TAG_GAP,
  EXPIRY_TAG_HEIGHT,
  EXPIRY_TAG_PADDING,
  EXPIRY_TAG_RADIUS_CSS,
  EXPIRY_TIER_FONT_SIZE,
  TExpiryDefinition
} from "./expiry-definitions";

const SubscriptionExpiryRow = withLiteObserverAndTheme<{
  labelKey: Ti18nKeys;
  definitions: TExpiryDefinition[];
}>((props) => {
  const { labelKey, definitions, theme } = props;
  const { colors, unitX, unitY } = theme;
  const advancedStore = getUserAdvancedStore();
  const userId = advancedStore.currentUserId.get();
  const data = advancedStore.userData.get(userId);

  const activeTiers = definitions
    .map((definition) => ({
      tierLabelKey: reduce(() => definition.labelKey, "PLUS"),
      tierColor: reduce(() => definition.tierColor, colors.all.davysGrey),
      expiresOn: reduce(() => `${data[definition.userKey]}`, "")
    }))
    .filter((tier) => !isBlankValue(tier.expiresOn));

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={FEATURE_ROW_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{ width: "100%", gap: FEATURE_ROW_GAP * unitX }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={FEATURE_ROW_LABEL_WIDTH}
        height={FEATURE_ROW_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{ flexShrink: 0 }}
        onClick={() => {}}
      >
        <Et3Text
          text={i18n.get(labelKey)}
          fontFamily="MEDIUM"
          fontSize={FEATURE_ROW_LABEL_FONT_SIZE}
          color={colors.all.davysGrey}
          isSpan={true}
          style={{ margin: 0 }}
        />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={FEATURE_ROW_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          flex: 1,
          minWidth: 0,
          flexWrap: "wrap",
          gap: `${EXPIRY_TAG_GAP * unitY}px ${EXPIRY_TAG_GAP * unitX}px`
        }}
        onClick={() => {}}
      >
        {activeTiers.length > 0 ? (
          activeTiers.map((tier) => (
            <ET3Div
              key={`${tier.tierLabelKey}-${tier.expiresOn}`}
              isScrollable={false}
              isExtendable={false}
              withShadow={false}
              width={0}
              height={EXPIRY_TAG_HEIGHT}
              fDirection="row"
              alignItems="center"
              justifyContent="center"
              color={colors.all.white}
              style={{
                boxSizing: "border-box",
                width: "auto",
                flexShrink: 0,
                whiteSpace: "nowrap",
                border: `1px solid ${tier.tierColor}`,
                borderRadius: EXPIRY_TAG_RADIUS_CSS,
                paddingLeft: EXPIRY_TAG_PADDING * unitX,
                paddingRight: EXPIRY_TAG_PADDING * unitX,
                gap: EXPIRY_TAG_GAP * unitX
              }}
              onClick={() => {}}
            >
              <Et3Text
                text={i18n.get(tier.tierLabelKey)}
                fontFamily="BOLD"
                fontSize={EXPIRY_TIER_FONT_SIZE}
                color={tier.tierColor}
                isSpan={true}
                style={{ margin: 0 }}
              />
              <Et3Text
                text={tier.expiresOn}
                fontFamily="LIGHT"
                fontSize={EXPIRY_DATE_FONT_SIZE}
                color={colors.all.davysGrey}
                isSpan={true}
                style={{ margin: 0 }}
              />
            </ET3Div>
          ))
        ) : (
          <ET3Div
            isScrollable={false}
            isExtendable={true}
            withShadow={false}
            width={0}
            height={EXPIRY_TAG_HEIGHT}
            fDirection="row"
            alignItems="center"
            justifyContent="flex-start"
            color={colors.all.transparent}
            style={{ width: "auto", border: SURFACE_BORDER, borderWidth: 0 }}
            onClick={() => {}}
          >
            <Et3Text
              text={i18n.get("NONE_ACTIVE")}
              fontFamily="LIGHT"
              fontSize={FEATURE_ROW_LABEL_FONT_SIZE}
              color={colors.all.gray}
              isSpan={true}
              style={{ margin: 0 }}
            />
          </ET3Div>
        )}
      </ET3Div>
    </ET3Div>
  );
});
export default SubscriptionExpiryRow;
